import { Dialog as BaseDialog } from '@base-ui/react/dialog';

import DialogBody from './dialog-body';
import DialogClose from './dialog-close';
import DialogContent from './dialog-content';
import DialogDescription from './dialog-description';
import DialogFooter from './dialog-footer';
import DialogHeader from './dialog-header';
import DialogTitle from './dialog-title';

type Props = {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  /** close 애니메이션 완료 후 호출 (overlay-kit unmount 용) */
  onExitComplete?: () => void;
};

const Dialog = ({ children, open, onOpenChange, onExitComplete }: Props) => {
  return (
    <BaseDialog.Root
      open={open}
      onOpenChange={onOpenChange}
      onOpenChangeComplete={(open) => {
        if (!open) {
          onExitComplete?.();
        }
      }}
    >
      {children}
    </BaseDialog.Root>
  );
};

Dialog.Content = DialogContent;
Dialog.Header = DialogHeader;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;
Dialog.Title = DialogTitle;
Dialog.Description = DialogDescription;
Dialog.Close = DialogClose;

export default Dialog;
